import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NewAuthService } from 'src/app/services/auth/new-auth-service.service';
import { PatientService } from 'src/app/services/patient.service';

@Component({
  selector: 'app-recently-touched-list',
  templateUrl: './recently-touched-list.component.html',
  styleUrls: ['./recently-touched-list.component.scss'],
})
export class RecentlyTouchedListComponent implements OnInit {
  patientRecentlyTouched$: Observable<any>;
  filterForm: UntypedFormGroup;
  showTypes: number[] = [5, 10, 20];

  constructor(
    private router: Router,
    private patientService: PatientService,
    private fb: UntypedFormBuilder,
    private auth: NewAuthService
  ) {}

  ngOnInit(): void {
    this.initializeForm();
    this.getPatientRecentlyTouched();
    this.setShowRecordListener();
  }

  initializeForm(): void {
    this.filterForm = this.fb.group({
      showRecordControl: [this.showTypes[1]],
    });
  }

  getPatientRecentlyTouched(value?: number): void {
    this.patientRecentlyTouched$ = this.patientService.getRecentlyTouchedUsers(this.auth.user?.user_id, value).pipe(
      map((docs) => {
        const mapById = new Map<string, { name: string; dates: Date[] }>();

        for (const doc of docs) {
          const patient_id = doc.patientId;
          const patient_name = doc.patientName;
          const date = doc.createdAt?.toDate();

          if (!mapById.has(patient_id)) {
            mapById.set(patient_id, { name: patient_name, dates: [] });
          }
          let entry = mapById.get(patient_id);
          if (!entry) {
            entry = { name: patient_name, dates: [] as Date[] };
            mapById.set(patient_id, entry);
          }
          if (date) {
            entry.dates.push(date);
          }
        }

        const grouped: any[] = Array.from(mapById.entries()).map(([patientId, v]) => ({
          patientId,
          patientName: v.name,
          dates: v.dates.sort((a, b) => b.getTime() - a.getTime()),
        }));

        return grouped;
      })
    );
  }

  setShowRecordListener(): void {
    this.filterForm.get('showRecordControl').valueChanges.subscribe((value) => {
      this.getPatientRecentlyTouched(Number(value));
    });
  }

  viewPatient(route: string, id: string, event: any): void {
    event.stopPropagation();
    this.router.navigateByUrl(`clinical/${route}/${id}`);
  }
}
